import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const FormTitle = styled.div`
  width: 100%;
  text-align: center;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.x3_large};
  font-weight: ${Variables.font_weight.medium}
  margin: 0 0 4px 0;
  padding: 0;
`;
export const TitleTag = styled.div`
  width: 100%;
  text-align: center;
  color: ${Variables.colors.complementary_800};
  font-size: ${Variables.font_sizes.x2_medium};
  font-weight: ${Variables.font_weight.regular};
  margin: 0 0 24px 0;
  padding: 0;
`;
export const TextsContainer = styled.div`
  .bold-text {
    color: ${Variables.colors.complementary_800};
    font-size: ${Variables.font_sizes.x_medium};
    font-weight: ${Variables.font_weight.medium};
    height: 19px;
  }
  .plan-info {
    color: ${Variables.colors.complementary_800};
    font-size: ${Variables.font_sizes.x_small};
    height: 19px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .amount {
      font-size: ${Variables.font_sizes.x2_medium};
      color: ${Variables.colors.complementary_800};
      span {
        margin-right: 8px;
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_800};
      }
    }
  }
  .plan-duration {
    color: ${Variables.colors.green_800};
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.medium};
    margin-bottom: 9px;
  }
  .plan-tax {
    color: ${Variables.colors.complementary_800};
    font-size: ${Variables.font_sizes.x_medium};
    margin-bottom: 6px;
    height: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .amount {
      font-size: ${Variables.font_sizes.x2_medium};
      color: ${Variables.colors.complementary_800};
      span {
        margin-right: 8px;
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_800};
      }
    }
  }

  .amount-row-green {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.green_800};
    margin-bottom: 6px;
    span.currency {
      font-weight: ${Variables.font_weight.light} !important;
      font-size: ${Variables.font_sizes.small};
      margin-right: 8px;
    }
    span.amount {
      font-size: ${Variables.font_sizes.x_small} !important;
      font-weight: ${Variables.font_weight.medium} !important;
      direction: ltr;
      text-align: left;
      display: inline-block;
    }
    & > span {
      &:first-child {
        width: 60%;
      }
      &:last-child {
        width: 40%;
        text-align: left;
      }
    }
  }
`;
export const AmountBox = styled.div`
  background-color: ${Variables.colors.complementary_50};
  width: 100%;
  border-radius: 23px;
  padding: 8px 19px;
  margin-bottom: 18px;
  margin-top: 18px;
  .amount-row {
    height: 22px;
    margin-bottom: 4px;
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_800};
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: ${Variables.font_weight.medium};
    &:last-child {
      margin-bottom: 0;
    }
    span.currency {
      font-weight: ${Variables.font_weight.light} !important;
      font-size: ${Variables.font_sizes.x_small};
      margin-right: 8px;
    }
    span.amount {
      font-size: ${Variables.font_sizes.x1_medium} !important;
      font-weight: ${Variables.font_weight.medium} !important;
      direction: ltr;
      text-align: left;
    }
  }
  // .amount-row-green {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   font-size: ${Variables.font_sizes.x_medium};
  //   color: ${Variables.colors.green_800};
  //   margin-bottom: 4px;
  //   span.currency {
  //     font-weight: ${Variables.font_weight.light} !important;
  //     font-size: ${Variables.font_sizes.x_medium};
  //     margin-right: 8px;
  //   }
  //   span.amount {
  //     font-size: ${Variables.font_sizes.x_medium} !important;
  //     font-weight: ${Variables.font_weight.medium} !important;
  //     direction: ltr;
  //     text-align: left;
  //     display: inline-block;
  //   }
  // }
`;
export const UseCreditBox = styled.div`
  border-radius: 4px;
  border: 1px solid ${Variables.colors.complementary_400};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  min-width: 396px;
  padding: 0 16px;
  font-size: ${Variables.font_sizes.x_medium};
  font-weight: ${Variables.font_weight.medium};
  color: ${Variables.colors.complementary_800};
  .credit-amount {
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.green_800};
    margin-right: 8px;
  }
  .credit-currency {
    font-weight: ${Variables.font_weight.light};
    font-size: ${Variables.font_sizes.x_small};
  }
`;
export const CreditFormBox = styled.div`
  height: 117px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${Variables.colors.complementary_400};
  margin-top: 13px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .form-control {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.complementary_800};
    font-weight: ${Variables.font_weight.medium};
    margin-bottom: 13px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .input {
      width: calc(100% - 153px);
    }
    .text {
      min-width: 111px;
    }
  }
`;

export const FormControlsBox = styled.div`
  width: 100%;
  min-height: 132px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  text-align: center;
  a {
    display: block;
    color: ${Variables.colors.primary_vivid};
    &:hover,
    &:visited,
    &:focus {
      color: ${Variables.colors.primary_vivid};
    }
  }
`;

export const FormMessage = styled.div`
  max-width: 373px;
  line-height: 1.58;
  margin-top: 16px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: ${Variables.font_sizes.x_small};
  color: ${Variables.colors.complementary_700};
  .form-message-icon {
    margin-left: 8px;
    &:before {
      font-size: 12px;
      margin: 0;
      color: ${Variables.colors.complementary_700};
    }
  }
`;
export const PlanOwnerBox = styled.div`
  width: 100%;
  text-align: center;
  color: ${Variables.colors.white};
  font-size: ${Variables.font_sizes.x_medium};
  padding: 8px 10px;
  background-color: ${Variables.colors.tertiary_800};
  border-radius: 8px;
  line-height: 1.46;
  margin-bottom: 8px;
`;
